import React from 'react';

interface PlusCpuIconProps {
  className?: string;
}

const PlusCpuIcon: React.FC<PlusCpuIconProps> = ({ className = "h-5 w-5" }) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M48.7694 10.6667H16.7694C13.8238 10.6667 11.436 13.0545 11.436 16V48C11.436 50.9455 13.8238 53.3333 16.7694 53.3333H48.7694C51.7149 53.3333 54.1027 50.9455 54.1027 48V16C54.1027 13.0545 51.7149 10.6667 48.7694 10.6667Z"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.77 5.33334V10.6667"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.77 53.3333V58.6667"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.10303 40H11.4364"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.10303 24H11.4364"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.104 40H59.4373"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.104 24H59.4373"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.77 5.33334V10.6667"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.77 53.3333V58.6667"
        stroke="currentColor"
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="30" y="21" width="5" height="23" rx="2.5" fill="currentColor" />
      <rect
        x="44"
        y="30"
        width="5"
        height="23"
        rx="2.5"
        transform="rotate(90 44 30)"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlusCpuIcon; 